export function formatEnumLabel(value: unknown): string {
  if (typeof value !== "string" || !value.trim()) {
    return "";
  }

  return value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
